import { useRef, useEffect } from 'react';
// dependencies
import { useId } from 'react';
// styling
import { switchCss } from '@digital_monorepo/styling';

const Switch = ({ label, checked, onChange, t, i18nPath }) => {
  const id = useId();
  const switchRef = useRef();

  useEffect(() => {
    if (switchRef && switchRef.current) {
      switchRef.current.setAttribute('data-no-text', t(`${i18nPath}.no`));
      switchRef.current.setAttribute('data-yes-text', t(`${i18nPath}.yes`));
    }
  }, [switchRef]);

  return (
    <>
      <div className={switchCss.toggleSwitch}>
        <input type='checkbox' className={switchCss.toggleSwitchCheckbox} name={'switchToggle'} id={id} checked={checked} onChange={onChange} />
        <label className={`${switchCss.toggleSwitchLabel} ${checked ? switchCss.toggleSwitchChecked : ''}`} htmlFor={id}>
          <span className={switchCss.toggleSwitchInner} ref={switchRef} />
          <span className={switchCss.toggleSwitchSwitch} />
        </label>
      </div>
      <span className={switchCss.fontLight}>{label}</span>
    </>
  );
};

export default Switch;
